import { render } from "./OpenAIParameters.vue?vue&type=template&id=7c49be9d&scoped=true"
import script from "./OpenAIParameters.vue?vue&type=script&lang=js"
export * from "./OpenAIParameters.vue?vue&type=script&lang=js"

import "./OpenAIParameters.vue?vue&type=style&index=0&id=7c49be9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c49be9d"]])

export default __exports__